
// Product page main section Tabbing
document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll("ul.tabs li");

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      var tab_id = tab.getAttribute("data-tab");

      // Remove active classes from all tabs and tab content
      tabs.forEach(function (t) {
        t.classList.remove("text-purple", "border-b-[3px]", "-mb-[2px]");
      });

      var tabContents = document.querySelectorAll(".tab-content");
      tabContents.forEach(function (content) {
        content.classList.add("hidden");
      });

      // Add active classes to the clicked tab and corresponding tab content
      tab.classList.add("text-purple", "border-b-[3px]", "-mb-[2px]");
      document.getElementById(tab_id).classList.remove("hidden");
    });
  });
});


// Product page quantity selector
document.querySelectorAll('.qtybox .btnqty').forEach(function(btn) {
  btn.addEventListener('click', function() {
    let qtyBox = this.closest('.qtybox');
    let qtyInput = qtyBox.querySelector('.quantity-input');
    let qty = parseInt(qtyInput.value);
    if (this.classList.contains('qtyplus')) {
      qty++;
    } else {
      if (qty > 1) {
        qty--;
      }
    }

    qty = isNaN(qty) ? 1 : qty;
    qtyInput.value = qty;
  });
});


// FAQ Accordion 

let openAnswerIndex = 0; // First item opened by default
// SVG icons for + and -
const plusIcon = `<svg class="size-20 text-purple" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M12 4v16m8-8H4"></path></svg>`;
const minusIcon = `<svg class="size-20 text-purple" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M20 12H4"></path></svg>`;

window.onload = function () {
  // Automatically open the first accordion item
  const initialAnswer = document.getElementById(`answer-0`);
  const initialIcon = document.getElementById(`icon-0`);

  if (initialAnswer && initialIcon) {
    initialAnswer.classList.add('open');
    initialIcon.innerHTML = minusIcon; // Set the first icon to the minus sign
  }
};
function toggleAnswer(index) {
  const currentAnswer = document.getElementById(`answer-${index}`);
  const currentIcon = document.getElementById(`icon-${index}`);

  // If the clicked answer is already open, close it
  if (openAnswerIndex === index) {
    currentAnswer.classList.remove('open');
    currentIcon.innerHTML = plusIcon;
    openAnswerIndex = null;
  } else {
    // Close the previously open answer (if any)
    if (openAnswerIndex !== null) {
      const prevAnswer = document.getElementById(`answer-${openAnswerIndex}`);
      const prevIcon = document.getElementById(`icon-${openAnswerIndex}`);
      prevAnswer.classList.remove('open');
      prevIcon.innerHTML = plusIcon;
    }

    // Open the clicked answer
    currentAnswer.classList.add('open');
    currentIcon.innerHTML = minusIcon;
    openAnswerIndex = index;
  }
}